import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment';
import { Link } from 'react-router-dom';

import {
  getFormsByObject, getCustomersByObject, getAccountsByObject, getLegalEntitiesByObject, getWorkflowQueueByObject, getUserQueueByObject,
  showAddFormModal, addForm, hideAddFormModal, showDeleteFormModal, hideDeleteFormModal,
  showAccountWithholdingModal, hideAccountWithholdingModal,
  showAssignToUserModal, hideAssignToUserModal, addBeneficiaryForm, changeImyBeneficiaryFormModal, hideAddBeneficiaryFormModal, takeQueueItem, hideOwnershipModal,
  assignFormsToUserWithCallback, deleteForms, getFormDetails, getCustomerDetails, clearFormDetails, clearCustomerDetails,
  showEditFormReferenceModal, hideEditFormReferenceModal, editFormReference, saveCriteria, showUnassignFormModal, hideUnassignFormModal, unassignFormsToUserWithCallback, showParentImyFormsModal, hideParentImyFormsModal
} from 'actions';

import FormWorkflowStages from 'common/Workflows/FormWorkflowStages';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

import ReactTable from 'components/ReactTable';

import SearchPanel from 'components/HomePage/SearchPanel';
import ActionSelect from 'components/HomePage/ActionSelect';
import formColumnDefs from 'components/HomePage/GridColumnDefinitions/formColumnDefs';
import accountColumnDefs from 'components/HomePage/GridColumnDefinitions/accountColumnDefs';
import customerColumnDefs from 'components/HomePage/GridColumnDefinitions/customerColumnDefs';
import legalEntityColumnDefs from 'components/HomePage/GridColumnDefinitions/legalEntityColumnDefs';
import workflowColumnDefs from 'components/HomePage/GridColumnDefinitions/workflowColumnDefs';
import FormsActions from 'components/HomePage/GridActions/FormsActions';
import AccountsActions from 'components/HomePage/GridActions/AccountsActions';
import CustomersActions from 'components/HomePage/GridActions/CustomersActions';

import AddFormModal from 'components/Modals/AddFormModal';
import AddBeneficiaryFormModal from 'components/Modals/AddBeneficiaryFormModal';
import DeleteFormModal from 'components/Modals/DeleteFormModal';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import WithholdingRatesModal from 'components/Modals/WithholdingRatesModal';
import CustomerImyFormsModal from 'components/Modals/CustomerImyFormsModal';
import AssignToUserModal from 'components/Modals/AssignToUserModal';
import UnassignToUserModal from 'components/Modals/UnassignToUserModal';
import EditFormReferenceModal from 'components/Modals/EditFormReferenceModalForm';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

const WAIT_INTERVAL = 500;

class Home extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    settings: PropTypes.shape().isRequired,
    formsCount: PropTypes.number.isRequired,
    isAddFormModalShown: PropTypes.bool.isRequired,
    isAssignToUserModalShown: PropTypes.bool.isRequired,
    isUnassignModalShown: PropTypes.bool.isRequired,
    isEditFormReferenceModalShown: PropTypes.bool,
    isDeleteFormModalShown: PropTypes.bool,
    isDeletingForm: PropTypes.bool,
    deleteFormError: PropTypes.string,
    isAccountWithholdingShown: PropTypes.bool.isRequired,
    isParentImyFormsShown: PropTypes.bool.isRequired,
    isAddBeneficiarFormModalShown: PropTypes.bool.isRequired,
    parentW8ImyForm: PropTypes.shape(),
    customers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    customersCount: PropTypes.number.isRequired,
    accounts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    accountsCount: PropTypes.number.isRequired,
    legalEntities: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    legalEntitiesCount: PropTypes.number.isRequired,
    isFetchingQueues: PropTypes.bool,
    isGettingAccounts: PropTypes.bool,
    isGettingCustomers: PropTypes.bool,
    isGettingForms: PropTypes.bool,
    isAddingImyToExistingLayer: PropTypes.bool,
    isOwnershipModalShown: PropTypes.bool,
    changeOwnershipItem: PropTypes.shape(),
    forms: PropTypes.arrayOf(PropTypes.shape()),
    userQueue: PropTypes.arrayOf(PropTypes.shape()),
    userCount: PropTypes.number,
    initialReviewQueue: PropTypes.arrayOf(PropTypes.shape()),
    initialReviewCount: PropTypes.number,
    secondaryReviewQueue: PropTypes.arrayOf(PropTypes.shape()),
    secondaryReviewCount: PropTypes.number,
    expertReviewQueue: PropTypes.arrayOf(PropTypes.shape()),
    expertReviewCount: PropTypes.number,
    completeQueue: PropTypes.arrayOf(PropTypes.shape()),
    completeCount: PropTypes.number,
    initSearchCriteria: PropTypes.shape(),
    initGridCriteria: PropTypes.shape(),
    formsList: PropTypes.arrayOf(PropTypes.number)
  };

  static defaultProps = {
    permissions: null,
    isDeleteFormModalShown: false,
    isDeletingForm: false,
    deleteFormError: null,
    isEditFormReferenceModalShown: false,
    parentW8ImyForm: null,
    isFetchingQueues: false,
    isGettingAccounts: false,
    isGettingCustomers: false,
    isGettingForms: false,
    isAddingImyToExistingLayer: false,
    isOwnershipModalShown: false,
    changeOwnershipItem: null,
    forms: [],
    userQueue: [],
    userCount: 0,
    initialReviewQueue: [],
    initialReviewCount: 0,
    secondaryReviewQueue: [],
    secondaryReviewCount: 0,
    expertReviewQueue: [],
    expertReviewCount: 0,
    completeQueue: [],
    completeCount: 0,
    initSearchCriteria: null,
    initGridCriteria: null,
    formsList: []
  };

  static getClassNameInitialReview(workflowType) {
    return workflowType === 'initialreview' ? 'col-20p' : 'col-15p';
  }

  static getClassNameWorkflow(workflowType) {
    return workflowType === 'mywork' ? 'col-15p' : 'col-15p';
  }

  constructor(props) {
    super(props);

    const { initGridCriteria, initSearchCriteria, permissions } = props;
    const searchCriteria = initSearchCriteria || {
      searchQuery: '',
      legalEntity: '',
      legalEntitySelected: false,
      accountNumber: '',
      accountNumberSelected: false,
      customer: '',
      customerSelected: false,
      formType: '',
      gridType: 'forms',
      workflowType: 'mywork'
    };
    const classNameInitialReview = Home.getClassNameInitialReview(searchCriteria.workflowType);
    const classNameWorkflow = Home.getClassNameWorkflow(searchCriteria.workflowType);
    const gridCriteria = initGridCriteria || {
      columnDefs: workflowColumnDefs(permissions, classNameInitialReview, classNameWorkflow).concat([]),
      pageIndex: 0,
      sortBy: [],
      filters: [],
      pageCount: 0,
      pageSize: 50,
      itemCount: 0,
      selectedItems: [],
      selectedItem: null
    };

    this.state = {
      data: [],
      showWorkflowButtons: searchCriteria.gridType === 'forms',
      loading: true,
      loadingTime: 500,
      initialLoaded: false,
      searchCriteria,
      gridCriteria
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    this.updateGridCriteriaState();
  }

  componentDidMount() {
    this.sendDataRequest();
  }

  /* eslint-disable react/no-did-update-set-state */
  componentDidUpdate(prevProps) {
    const { searchCriteria: { gridType, workflowType }, initialLoaded } = this.state;
    const { forms, formsCount, userQueue, userCount, initialReviewQueue, initialReviewCount, secondaryReviewQueue, secondaryReviewCount, expertReviewQueue,
      expertReviewCount, completeQueue, completeCount, customers, customersCount, accounts, accountsCount, legalEntities, legalEntitiesCount } = this.props;
    switch (gridType) {
      case 'forms':
        switch (workflowType) {
          case 'mywork':
            if (userQueue !== prevProps.userQueue) {
              this.processData(userQueue, userCount);
              this.hideLoadingAnimation();
              if (!initialLoaded) {
                this.setState({ initialLoaded: true });
              }
            }
            break;
          case 'initialreview':
            if (initialReviewQueue !== prevProps.initialReviewQueue) {
              this.processData(initialReviewQueue, initialReviewCount);
              this.hideLoadingAnimation();
              if (!initialLoaded) {
                this.setState({ initialLoaded: true });
              }
            }
            break;
          case 'secondaryreview':
            if (secondaryReviewQueue !== prevProps.secondaryReviewQueue) {
              this.processData(secondaryReviewQueue, secondaryReviewCount);
              this.hideLoadingAnimation();
              if (!initialLoaded) {
                this.setState({ initialLoaded: true });
              }
            }
            break;
          case 'managerreview':
            if (expertReviewQueue !== prevProps.expertReviewQueue) {
              this.processData(expertReviewQueue, expertReviewCount);
              this.hideLoadingAnimation();
              if (!initialLoaded) {
                this.setState({ initialLoaded: true });
              }
            }
            break;
          case 'complete':
            if (completeQueue !== prevProps.completeQueue) {
              this.processData(completeQueue, completeCount);
              this.hideLoadingAnimation();
              if (!initialLoaded) {
                this.setState({ initialLoaded: true });
              }
            }
            break;
          case 'allforms':
            if (forms !== prevProps.forms) {
              this.processData(forms, formsCount);
              this.hideLoadingAnimation();
              if (!initialLoaded) {
                this.setState({ initialLoaded: true });
              }
            }
            break;
          default:
            console.error(`Default workflow: ${ workflowType }`);
        }
        break;
      case 'customers':
        if (customers !== prevProps.customers) {
          this.processData(customers, customersCount);
          this.hideLoadingAnimation();
          if (!initialLoaded) {
            this.setState({ initialLoaded: true });
          }
        }
        break;
      case 'accounts':
        if (accounts !== prevProps.accounts) {
          this.processData(accounts, accountsCount);
          this.hideLoadingAnimation();
          if (!initialLoaded) {
            this.setState({ initialLoaded: true });
          }
        }
        break;
      case 'legalEntities':
        if (legalEntities !== prevProps.legalEntities) {
          this.processData(legalEntities, legalEntitiesCount);
          this.hideLoadingAnimation();
          if (!initialLoaded) {
            this.setState({ initialLoaded: true });
          }
        }
        break;
      default:
        console.error(`Default grid: ${ gridType }`);
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    const { gridCriteria, searchCriteria } = this.state;
    dispatch(saveCriteria(searchCriteria, gridCriteria));
  }

  /* eslint-enable react/no-did-update-set-state */

  get isSearchCriteriaValid() {
    const { searchCriteria } = this.state;

    const isEmpty = searchCriteria
      && searchCriteria.searchQuery?.length === 0
      && !searchCriteria.customer
      && !searchCriteria.legalEntity
      && !searchCriteria.accountNumber;

    return (searchCriteria
      && (isEmpty || searchCriteria.searchQuery?.length >= 3
        || searchCriteria.customerSelected || searchCriteria.legalEntitySelected || searchCriteria.accountNumberSelected
        || searchCriteria.customer?.length >= 3 || searchCriteria.legalEntity?.length >= 3 || searchCriteria.accountNumber?.length >= 3));
  }

  hideLoadingAnimation = () => {
    const { loadingTime } = this.state;
    const { isGettingForms, isGettingAccounts, isGettingCustomers, isFetchingQueues } = this.props;
    const loadingInterval = setInterval(() => {
      if (!isGettingForms && !isGettingAccounts && !isGettingCustomers && !isFetchingQueues) {
        this.setState({ loading: false });
        clearInterval(loadingInterval);
      }
    }, loadingTime);
  };

  updateGridCriteriaState = () => {
    const { searchCriteria: { gridType, workflowType }, gridCriteria } = this.state;
    const { permissions } = this.props;
    let colDefs = [];
    switch (gridType) {
      case 'forms':
        switch (workflowType) {
          case 'mywork':
          case 'initialreview':
          case 'secondaryreview':
          case 'managerreview':
          case 'complete':
            colDefs = this.getWorkflowColumns(workflowType);
            this.setState({ gridCriteria: { ...gridCriteria, columnDefs: colDefs } });
            break;
          case 'allforms':
            colDefs = formColumnDefs(permissions);
            this.setState({ gridCriteria: { ...gridCriteria, columnDefs: colDefs } });
            break;
          default:
            break;
        }
        break;
      case 'customers':
        colDefs = customerColumnDefs(permissions);
        this.setState({ gridCriteria: { ...gridCriteria, columnDefs: colDefs } });
        break;
      case 'accounts':
        colDefs = accountColumnDefs(permissions);
        this.setState({ gridCriteria: { ...gridCriteria, columnDefs: colDefs } });
        break;
      case 'legalEntities':
        colDefs = legalEntityColumnDefs(permissions);
        this.setState({ gridCriteria: { ...gridCriteria, columnDefs: colDefs } });
        break;
      default:
        break;
    }
  };

  processData = (items, itemCount) => {
    const { gridCriteria } = this.state;
    const data = [];
    if (items != null) {
      items.forEach((item) => {
        let isActive = 'N/A';
        if (item.isActive != null) {
          isActive = item.isActive ? 'Active' : 'Inactive';
        }
        let isFinancialAccount = 'N/A';
        if (item.isFinancialAccount != null) {
          isFinancialAccount = item.isFinancialAccount ? 'Yes' : 'No';
        }
        let isDirect = 'N/A';
        if (item.isDirect != null) {
          isDirect = item.isDirect ? 'Yes' : 'No';
        }
        let isValid = 'N/A';
        if (item.isValid != null) {
          isValid = item.isValid ? 'Valid' : 'Invalid';
        }
        let formType = (item?.formType == null || item?.formType === '') ? 'N/A' : item?.formType;
        if (item.formTypeString != null) {
          formType = item?.formTypeString;
        }
        let legalEntityIsActive = 'N/A';
        if (item.legalEntityIsActive != null) {
          legalEntityIsActive = item.legalEntityIsActive ? 'Active' : 'Inactive';
        }
        let accountIsActive = 'N/A';
        if (item.accountIsActive != null) {
          accountIsActive = item.accountIsActive ? 'Active' : 'Inactive';
        }
        let customerIsActive = 'N/A';
        if (item.customerIsActive != null) {
          customerIsActive = item.customerIsActive ? 'Active' : 'Inactive';
        }

        const datum = {
          itemId: item?.id,
          accountId: item?.accountId,
          customerDbId: item?.customerDbId,
          // accounts
          accountName: (item?.accountName == null || item?.accountName === '') ? 'N/A' : item?.accountName,
          accountNumber: (item?.accountNumber == null || item?.accountNumber === '') ? 'N/A' : item?.accountNumber,
          legalEntityName: (item?.legalEntityName == null || item?.legalEntityName === '') ? 'N/A' : item?.legalEntityName,
          parentAccountName: (item?.parentAccountName == null || item?.parentAccountName === '') ? 'N/A' : item?.parentAccountName,
          isFinancialAccount,
          isActive,
          // customers
          customerName: (item?.customerName == null || item?.customerName === '') ? 'N/A' : item?.customerName,
          customerId: (item?.customerId == null || item?.customerId === '') ? 'N/A' : item?.customerId,
          chapter3StatusDescription: (item?.chapter3StatusDescription == null || item?.chapter3StatusDescription === '') ? 'N/A' : item?.chapter3StatusDescription,
          chapter4StatusDescription: (item?.chapter4StatusDescription == null || item?.chapter4StatusDescription === '') ? 'N/A' : item?.chapter4StatusDescription,
          crsClassificationDescription: (item?.crsClassificationDescription == null || item?.crsClassificationDescription === '') ? 'N/A' : item?.crsClassificationDescription,
          // legal entities
          legalEntityClientIdentifier: (item?.legalEntityClientIdentifier == null || item?.legalEntityClientIdentifier === '') ? '' : item?.legalEntityClientIdentifier,
          legalEntityIsActive,
          accountIsActive,
          customerIsActive,
          // forms
          formTypeDescription: item?.formTypeDescription ?? 'N/A',
          formType,
          formTypeString: item?.formTypeString,
          workflowStage: item?.workflowStage,
          workflowPreviousUsername: (item?.workflowPreviousUsername === null || item?.workflowPreviousUsername === '') ? 'N/A' : item.workflowPreviousUsername,
          formSourceDescription: (item?.formSourceDescription == null || item?.formSourceDescription === '') ? 'N/A' : item?.formSourceDescription,
          workflowStageDescription: (item?.workflowStageDescription == null || item?.workflowStageDescription === '') ? 'N/A' : item?.workflowStageDescription,
          workflowUsername: (item?.workflowUsername == null || item?.workflowUsername === '') ? 'N/A' : item?.workflowUsername,
          workflowStatus: (item?.workflowStatus == null || item?.workflowStatus === '') ? 'N/A' : item?.workflowStatus,
          lastActionDate: (item?.lastActionDate == null || item?.lastActionDate === '') ? 'N/A' : moment(item.lastActionDate).format('MMM DD, YYYY HH:mm:ss'),
          isValid,
          validationDate: (item?.validationDate == null || item?.validationDate === '') ? 'N/A' : moment(item.validationDate).format('MMM DD, YYYY HH:mm:ss'),
          uploadedBy: (item?.uploadedBy == null || item?.uploadedBy === '') && (!item.formCreatedByUsername || item.formCreatedByUsername === '') ? 'N/A' : item?.uploadedBy || item?.formCreatedByUsername,
          validityDescription: (item?.validityDescription == null || item?.validityDescription === '') ? 'N/A' : item?.validityDescription,
          // all
          isOnlineForm: (item?.isOnlineForm == null || item?.isOnlineForm === '') ? 'N/A' : item?.isOnlineForm,
          allocationStmtType: (item?.allocationStmtType == null || item?.allocationStmtType === '') ? 'N/A' : item?.allocationStmtType,
          allocationStmtName: (item?.allocationStmtName == null || item?.allocationStmtName === '') ? 'N/A' : item?.allocationStmtName,
          hasAllocationStmt: (item?.hasAllocationStmt == null || item?.hasAllocationStmt === '') ? 'N/A' : item?.hasAllocationStmt,
          hasParentForm: (item?.hasParentForm == null || item?.hasParentForm === '') ? 'N/A' : item?.hasParentForm,
          hasImyStructure: (item?.hasImyStructure == null) ? false : item?.hasImyStructure,
          isDirect,
          parentFormId: (item?.parentFormId == null || item?.parentFormId === '') ? 'N/A' : item?.parentFormId,
          additionalData: item.additionalData ?? null,
          isLoadingDetails: item?.isLoadingDetails,
          emailAddress: (item?.emailAddress == null || item?.emailAddress === '') ? 'N/A' : item?.emailAddress,
        };
        data.push(datum);
      });
      const pageCount = Math.ceil(itemCount / gridCriteria.pageSize);
      this.setState({ data, gridCriteria: { ...gridCriteria, itemCount, pageCount } });
    }
  };

  generateRequest = () => {
    const { searchCriteria, gridCriteria } = this.state;
    const formTypeArray = (searchCriteria.formType === '' || searchCriteria.formType == null) ? null : [searchCriteria.formType];
    let sortDirection;
    if (gridCriteria.sortBy != null && gridCriteria.sortBy[0]) {
      if (gridCriteria.sortBy[0]?.desc != null) {
        sortDirection = gridCriteria.sortBy[0]?.desc ? 'desc' : 'asc';
      }
    } else {
      sortDirection = null;
    }
    return ({
      pageNumber: gridCriteria.pageIndex + 1,
      pageSize: gridCriteria.pageSize,
      sortByField: gridCriteria.sortBy != null ? gridCriteria.sortBy[0]?.id : null,
      sortDirection,
      filterList: gridCriteria.filters,
      searchQuery: searchCriteria.searchQuery === '' ? null : searchCriteria.searchQuery?.trim(),
      legalEntity: !searchCriteria.legalEntity ? null : (searchCriteria.legalEntity?.id || searchCriteria.legalEntity),
      legalEntitySelected: searchCriteria.legalEntitySelected,
      accountNumber: !searchCriteria.accountNumber ? null : (searchCriteria.accountNumber?.id || searchCriteria.accountNumber),
      accountNumberSelected: searchCriteria.accountNumberSelected,
      customer: !searchCriteria.customer ? null : (searchCriteria.customer?.id || searchCriteria.customer),
      customerSelected: searchCriteria.customerSelected,
      formTypes: formTypeArray
    });
  };

  getWorkflowColumns = (workflowType) => {
    const { permissions } = this.props;
    const colDefs = [];
    const classNameInitialReview = Home.getClassNameInitialReview(workflowType);
    const classNameWorkflow = Home.getClassNameWorkflow(workflowType);
    const workflowColumns = workflowColumnDefs(permissions, classNameInitialReview, classNameWorkflow);
    for (let i = 0, len = workflowColumns.length; i < len; i += 1) {
      colDefs.push({ ...workflowColumns[i] });
    }

    colDefs[3].isVisible = workflowType === 'mywork';
    colDefs[6].Header = workflowType === 'managerreview' ? 'Referred By' : colDefs[6].Header;
    colDefs[6].isVisible = (workflowType === 'secondaryreview' || workflowType === 'managerreview');
    colDefs[7].Header = workflowType === 'complete' ? 'Completed By' : colDefs[7].Header;
    colDefs[7].isVisible = (workflowType === 'complete');
    return colDefs;
  };

  onWorkflowTypeChanged = (workflowType) => {
    const { gridCriteria, searchCriteria } = this.state;
    const { permissions } = this.props;

    if (workflowType === searchCriteria.workflowType) {
      return;
    }

    if (workflowType === 'allforms') {
      const colDefs = formColumnDefs(permissions);
      this.setState({ loading: true, searchCriteria: { ...searchCriteria, workflowType }, gridCriteria: { ...gridCriteria, columnDefs: colDefs, filters: [], sortBy: [] } }, () => this.sendDataRequest());
    } else {
      const colDefs = this.getWorkflowColumns(workflowType);
      this.setState({ loading: true, searchCriteria: { ...searchCriteria, workflowType }, gridCriteria: { ...gridCriteria, columnDefs: colDefs, filters: [], sortBy: [] } }, () => this.sendDataRequest());
    }
  };

  onSearchCriteriaChanged = (newSearchCriteria) => {
    const { gridCriteria } = this.state;
    let { searchCriteria } = this.state;
    const { permissions } = this.props;

    let gridChanged = false;
    const showWorkflowButtons = newSearchCriteria.gridType === 'forms';

    if (newSearchCriteria.gridType !== searchCriteria.gridType) {
      searchCriteria = newSearchCriteria;
      gridCriteria.selectedItem = null;
      gridCriteria.selectedItems = [];
      gridCriteria.filters = [];
      gridCriteria.sortBy = [];
      gridChanged = true;
    }

    const criteria = { ...gridCriteria };
    if (gridChanged) {
      let columnDefs = formColumnDefs(permissions);
      if (searchCriteria.gridType === 'forms' && searchCriteria.workflowType !== 'allforms') {
        columnDefs = this.getWorkflowColumns(searchCriteria.workflowType);
      } else if (searchCriteria.gridType === 'customers') {
        columnDefs = customerColumnDefs(permissions);
      } else if (searchCriteria.gridType === 'accounts') {
        columnDefs = accountColumnDefs(permissions);
      } else if (searchCriteria.gridType === 'legalEntities') {
        columnDefs = legalEntityColumnDefs(permissions);
      }
      criteria.columnDefs = columnDefs;
    }

    this.setState({ loading: gridChanged, searchCriteria: { ...searchCriteria, ...newSearchCriteria }, showWorkflowButtons, gridCriteria: criteria }, (() => {
      if (gridChanged) {
        this.sendDataRequest();
      } else {
        this.fetchData();
      }
    }));
  };

  onGridCriteriaChanged = (newGridCriteria) => {
    this.setState({ gridCriteria: { ...newGridCriteria } }, () => this.fetchData());
  };

  onRowSelectionChanged = (rowSelections) => {
    const { gridCriteria } = this.state;
    this.setState({ gridCriteria: { ...gridCriteria, ...rowSelections } });
  };

  onRowExpandedStateChanged = (row, expand) => {
    const { dispatch } = this.props;
    const { searchCriteria: { gridType } } = this.state;

    if (expand) {
      if (gridType === 'forms') {
        dispatch(getFormDetails(row.original.itemId, parseInt(row.id, 10)));
      }
      if (gridType === 'customers') {
        dispatch(getCustomerDetails(row.original.itemId, row.original.accountId, parseInt(row.id, 10)));
      }
    } else {
      if (gridType === 'forms') {
        dispatch(clearFormDetails(row.original.itemId, parseInt(row.id, 10)));
      }
      if (gridType === 'customers') {
        dispatch(clearCustomerDetails(row.original.itemId, parseInt(row.id, 10)));
      }
    }
  };

  addFormAction = (parentForm, values, onlineForm) => {
    const { dispatch } = this.props;
    dispatch(addForm(parentForm, values, onlineForm));
  };

  closeAddFormModal = () => {
    const { dispatch } = this.props;
    dispatch(hideAddFormModal());
  };

  openAssignToUserModal = (multipleItems) => {
    const { dispatch } = this.props;
    const selectedItemIds = Array.from(multipleItems, x => x.itemId);
    dispatch(showAssignToUserModal(selectedItemIds));
  };

  closeAssignToUserModal = () => {
    const { dispatch } = this.props;
    dispatch(hideAssignToUserModal());
  };

  processAssignToUsers = (_, user) => {
    const { dispatch } = this.props;
    const { gridCriteria } = this.state;
    const selectedItemIds = Array.from(gridCriteria.selectedItems, x => x.itemId);
    dispatch(assignFormsToUserWithCallback(selectedItemIds, user, () => this.fetchData()));
  };

  getItemsList = () => {
    const { formsList } = this.props;
    return formsList;
  };

  openDeleteFormModal = (item) => {
    const { dispatch } = this.props;
    const { gridCriteria } = this.state;
    const selectedObjects = [];
    if (!item) {
      for (let i = 0; i < gridCriteria.selectedItems.length; i += 1) {
        const listItem = gridCriteria.selectedItems.filter(x => x.itemId === gridCriteria.selectedItems[i].itemId)[0];
        selectedObjects.push({ customerDbId: listItem.customerDbId, customerName: listItem.customerName, customerId: listItem.customerId });
      }
    } else {
      this.setState({ gridCriteria: { ...gridCriteria, selectedItem: item } });
      selectedObjects.push({ customerDbId: item.customerDbId, customerName: item.customerName, customerId: item.customerId });
    }
    dispatch(showDeleteFormModal(selectedObjects));
  };

  closeDeleteFormModal = () => {
    const { dispatch } = this.props;
    dispatch(hideDeleteFormModal());
  };

  processDeleteForms = () => {
    const { dispatch } = this.props;
    const { gridCriteria } = this.state;
    if (gridCriteria.selectedItem != null) {
      // if selectedItem exists, then delete that item (this is the item for the row with the delete icon that was pressed)
      dispatch(deleteForms([gridCriteria.selectedItem.itemId], () => {
        this.setState({ gridCriteria: { ...gridCriteria, selectedItem: null } }, () => this.fetchData());
      }));
    } else {
      // otherwise, delete all the selectedItems
      const selectedItemIds = Array.from(gridCriteria.selectedItems, x => x.itemId);
      dispatch(deleteForms(selectedItemIds, () => {
        this.setState({ gridCriteria: { ...gridCriteria, selectedItems: [] } }, () => this.fetchData());
      }));
    }
    this.closeDeleteFormModal();
  };

  openAccountWithholdingModal = (item, tableType) => {
    const { dispatch } = this.props;

    if (tableType === 'forms') {
      dispatch(showAccountWithholdingModal(item.itemId, null, null));
    }

    if (tableType === 'customers') {
      dispatch(showAccountWithholdingModal(null, item.itemId, null));
    }

    if (tableType === 'accounts') {
      dispatch(showAccountWithholdingModal(null, null, item.itemId));
    }
  };

  closeAccountWithholdingModal = () => {
    const { dispatch } = this.props;
    dispatch(hideAccountWithholdingModal());
  };

  openCustomerImyFormsModal = (item) => {
    const { dispatch } = this.props;
    dispatch(showParentImyFormsModal(item.itemId, null));
  };

  openAccountImyFormsModal = (item) => {
    const { dispatch } = this.props;
    dispatch(showParentImyFormsModal(null, item.itemId));
  };

  closeParentImyFormsModal = () => {
    const { dispatch } = this.props;
    dispatch(hideParentImyFormsModal());
  };

  openAddFormModal = (form) => {
    const { dispatch } = this.props;
    dispatch(showAddFormModal(form, form !== null));
  };

  openEditFormReferenceModal = () => {
    const { dispatch, forms } = this.props;
    const { gridCriteria } = this.state;
    const selectedObjects = [];

    if (!gridCriteria.selectedItems || gridCriteria.selectedItems.length <= 0) {
      return;
    }

    for (let i = 0; i < gridCriteria.selectedItems.length; i += 1) {
      const item = forms.filter(x => x.id === gridCriteria.selectedItems[i].itemId)[0];
      selectedObjects.push(item);
    }

    if (selectedObjects.length > 0) {
      dispatch(showEditFormReferenceModal(selectedObjects));
    }
  };

  openUnassignToUserModal = (item) => {
    const { dispatch } = this.props;
    const { gridCriteria } = this.state;

    const selectedObjects = [];
    this.setState({ gridCriteria: { ...gridCriteria, selectedItem: item } });
    selectedObjects.push({ customerDbId: item.customerDbId, customerName: item.customerName, customerId: item.customerId });
    dispatch(showUnassignFormModal(item.itemId));
  };

  closeUnassignFormModal = () => {
    const { dispatch } = this.props;
    dispatch(hideUnassignFormModal());
  };

  processUnassignToUsers = () => {
    const { dispatch } = this.props;
    const { gridCriteria } = this.state;

    if (gridCriteria.selectedItem != null) {
      // if selectedItem exists, then delete that item (this is the item for the row with the delete icon that was pressed)
      dispatch(unassignFormsToUserWithCallback([gridCriteria.selectedItem.itemId], () => {
        this.setState({ gridCriteria: { ...gridCriteria, selectedItem: null } }, () => this.fetchData());
      }));
    }
  };

  closeEditFormReferenceModal = () => {
    const { dispatch } = this.props;
    dispatch(hideEditFormReferenceModal());
  };

  processEditFormReference = (formId, newFormRef) => {
    const { dispatch } = this.props;
    dispatch(editFormReference(formId, newFormRef));
  };

  addBeneficiaryForms = (values) => {
    const { dispatch, parentW8ImyForm } = this.props;
    dispatch(addBeneficiaryForm(values, parentW8ImyForm));
  };

  imyChange = (value) => {
    const { dispatch } = this.props;
    dispatch(changeImyBeneficiaryFormModal(value === true));
  };

  closeAddBeneficiaryFormModal = (item) => {
    const { dispatch } = this.props;
    dispatch(hideAddBeneficiaryFormModal(item));
  };

  closeFromOwnershipModal = (item) => {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal(item));
  };

  reAssignItem = () => {
    const { dispatch, changeOwnershipItem } = this.props;
    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('form', changeOwnershipItem.id, changeOwnershipItem.accountId));
      dispatch(hideOwnershipModal());
    }
  };

  continueFromOwnershipModal = () => {
    const { dispatch, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    let redirectUrl = `/forms/${ changeOwnershipItem.formType.toLowerCase() }/${ changeOwnershipItem.id }`;
    if (changeOwnershipItem.accountId) {
      redirectUrl = `${ redirectUrl }?account=${ changeOwnershipItem.accountId }`;
    }
    dispatch(push(redirectUrl));
  };

  onTakeQueueItem = (item) => {
    const { dispatch } = this.props;
    const { searchCriteria: { workflowType } } = this.state;
    const { formTypeString, workflowStage } = item;
    const id = item.itemId;
    const isPendingStage = workflowStage === FormWorkflowStages.PendingReview || workflowStage === FormWorkflowStages.PendingSecondaryReview || workflowStage === FormWorkflowStages.PendingExpertReview;

    if ((workflowType !== 'mywork' || isPendingStage) && id) {
      dispatch(takeQueueItem('form', id));
    } else if (workflowType === 'mywork' && id) {
      dispatch(push(`/forms/${ formTypeString }/${ id }`));
    }
  };

  sendDataRequest = () => {
    const { dispatch } = this.props;
    const { searchCriteria, gridCriteria } = this.state;

    const request = this.generateRequest();
    switch (searchCriteria.gridType) {
      case 'forms':
        if (searchCriteria.workflowType === 'allforms') {
          dispatch(getFormsByObject(request));
        } else {
          let sortDirection;
          if (gridCriteria.sortBy != null && gridCriteria.sortBy[0]) {
            if (gridCriteria.sortBy[0]?.desc != null) {
              sortDirection = gridCriteria.sortBy[0]?.desc ? 'desc' : 'asc';
            }
          } else {
            sortDirection = null;
          }

          const formTypeArray = (searchCriteria.formType === '' || searchCriteria.formType == null) ? null : [searchCriteria.formType];
          const workflowRequest = {
            workflow: 'form',
            pageNumber: request.pageNumber,
            pageSize: gridCriteria.pageSize,
            sortByField: gridCriteria.sortBy != null ? gridCriteria.sortBy[0]?.id : null,
            sortDirection,
            stage: searchCriteria.workflowType,
            searchQuery: searchCriteria.searchQuery,
            legalEntity: !searchCriteria.legalEntity ? null : (searchCriteria.legalEntity?.id || searchCriteria.legalEntity),
            legalEntitySelected: searchCriteria.legalEntitySelected,
            accountNumber: !searchCriteria.accountNumber ? null : (searchCriteria.accountNumber?.id || searchCriteria.accountNumber),
            accountNumberSelected: searchCriteria.accountNumberSelected,
            customer: !searchCriteria.customer ? null : (searchCriteria.customer?.id || searchCriteria.customer),
            customerSelected: searchCriteria.customerSelected,
            formTypes: formTypeArray,
            filterList: gridCriteria.filters
          };

          switch (searchCriteria.workflowType) {
            case 'mywork':
              dispatch(getUserQueueByObject(workflowRequest));
              break;
            case 'initialreview':
              workflowRequest.stage = 'pendingreview';
              dispatch(getWorkflowQueueByObject(workflowRequest));
              break;
            case 'secondaryreview':
              workflowRequest.stage = 'pendingsecondaryreview';
              dispatch(getWorkflowQueueByObject(workflowRequest));
              break;
            case 'managerreview':
              workflowRequest.stage = 'pendingexpertreview';
              dispatch(getWorkflowQueueByObject(workflowRequest));
              break;
            case 'complete':
              workflowRequest.stage = 'complete';
              dispatch(getWorkflowQueueByObject(workflowRequest));
              break;
            default:
              console.error(`Default case hit: ${ searchCriteria.workflowType }`);
          }
        }
        break;
      case 'customers':
        dispatch(getCustomersByObject(request));
        break;
      case 'accounts':
        dispatch(getAccountsByObject(request));
        break;
      case 'legalEntities':
        dispatch(getLegalEntitiesByObject(request));
        break;
      default:
        console.error(`Default case hit: ${ searchCriteria.gridType }`);
    }
  };

  fetchData = () => {
    const { gridCriteria, loading } = this.state;

    if (loading) {
      return;
    }
    clearTimeout(this.timer);

    if (this.isSearchCriteriaValid) {
      this.setState({ loading: true, gridCriteria: { ...gridCriteria, selectedItems: [] } }, () => {
        this.timer = setTimeout(() => {
          this.sendDataRequest();
        }, WAIT_INTERVAL);
      });
    }
  };

  getActions = () => {
    const { searchCriteria: { gridType, workflowType } } = this.state;
    const { permissions, settings } = this.props;

    switch (gridType) {
      case 'forms':
        return FormsActions({
          permissions,
          settings,
          workflowType,
          openAddFormModal: this.openAddFormModal,
          openAccountWithholdingModal: this.openAccountWithholdingModal,
          openDeleteFormModal: this.openDeleteFormModal,
          onTakeQueueItem: this.onTakeQueueItem,
          openUnassignFormModal: this.openUnassignToUserModal,
          navigateToImyStructure: this.navigateToImyStructure,
          navigateToWithholdingStatement: this.navigateToWithholdingStatement
        });
      case 'customers':
        return CustomersActions({
          permissions,
          settings,
          openAccountWithholdingModal: this.openAccountWithholdingModal,
          openCustomerImyFormsModal: this.openCustomerImyFormsModal
        });
      case 'accounts':
        return AccountsActions({
          permissions,
          settings,
          openAccountWithholdingModal: this.openAccountWithholdingModal,
          openAccountImyFormsModal: this.openAccountImyFormsModal
        });
      default:
        return null;
    }
  };

  getIsSelectionEnabled = () => {
    const { permissions } = this.props;
    const { searchCriteria: { gridType, workflowType } } = this.state;
    return (
      AccessControl.hasPermission(
        permissions,
        [
          ActivityPerms.scannedDeleteCompleteForms,
          ActivityPerms.electronicDeleteCompleteForms,
          ActivityPerms.scannedDeleteInReviewForms,
          ActivityPerms.electronicDeleteInReviewForms,
          ActivityPerms.scannedUpload,
          ActivityPerms.scannedValidate,
          ActivityPerms.scannedEdit,
          ActivityPerms.fwfReassignToUser
        ]
      )
    ) && gridType === 'forms' && workflowType === 'allforms';
  };

  getIsExpandCollapseEnabled = () => {
    const { searchCriteria: { gridType, workflowType } } = this.state;
    return (gridType === 'forms' && workflowType === 'allforms') || gridType === 'customers';
  };

  getChildRowLayout = (childData) => {
    const { searchCriteria: { gridType } } = this.state;

    if (gridType === 'forms') {
      return <React.Fragment>
        { childData.legalEntities != null && <div className="child-data-item">
          <label>Legal Entity</label>
          <span>{ childData.legalEntities.map(l => <React.Fragment>{ l }<br /></React.Fragment>) }</span></div> }
        { (!childData.legalEntities || childData.legalEntities.length === 0) && <div className="child-data-item">
          <label>Legal Entity</label>
          <span>N/A</span></div> }
        <div className="child-data-item"><label>Uploaded At</label><span>{ childData.uploadDate ? moment(childData.uploadDate).format('MMM DD, YYYY, HH:mm:ss') : 'N/A' }</span></div>
        <div className="child-data-item"><label>Form Reference</label><span>{ childData.reference ?? 'N/A' }</span></div>
        <div className="child-data-item"><label>KYC Check Complete?</label><span>{ childData.isKycReviewed ? 'Yes' : 'No' }</span></div>
        <div className="child-data-item"><label>Expiration Date</label>
          <span>
            { !childData.validUntil && 'N/A' }
            { childData.validUntil && childData.validUntil.includes('9999') && 'Evergreen' }
            { childData.validUntil && !childData.validUntil.includes('9999') && moment(childData.validUntil).format('MMM DD, YYYY') }
            { childData.expiryReason ? ` (${ childData.expiryReasonDescription })` : '' }
          </span>
        </div>
      </React.Fragment>;
    }
    if (gridType === 'customers') {
      return <React.Fragment>
        { childData.legalEntities != null && <div className="child-data-item">
          <label>Legal Entity</label>
          <span>{ childData.legalEntities.map(l => <React.Fragment>{ l }<br /></React.Fragment>) }</span></div> }
        { (!childData.legalEntities || childData.legalEntities.length === 0) && <div className="child-data-item">
          <label>Legal Entity</label>
          <span>N/A</span></div> }
        <div className="child-data-item"><label>Address Line 1 -2</label><span>{ childData.permAddressLine1 ? childData.permAddressLine1 : 'N/A' }</span></div>
        <div className="child-data-item"><label>Address Line 3 - 4</label><span>{ childData.permAddressLine2 ? childData.permAddressLine2 : 'N/A' }</span></div>
        <div className="child-data-item"><label>Postal Code</label><span>{ childData.permAddrPostalCode ? childData.permAddrPostalCode : 'N/A' }</span></div>
        <div className="child-data-item"><label>Residency Country</label><span>{ childData.permAddrCountry ? childData.permAddrCountry : 'N/A' }</span></div>
        <div className="child-data-item"><label>Treaty Country</label><span>{ childData.treatyCountry ? childData.treatyCountry : 'N/A' }</span></div>
        <div className="child-data-item"><label>DOB</label><span>{ childData.dob ? moment(childData.dob).format('MMM DD, YYYY') : 'N/A' }</span></div>
      </React.Fragment>;
    }
    return null;
  };

  navigateToImyStructure = (formData) => {
    const { dispatch } = this.props;
    dispatch(push(`/w8imystructure/${ formData != null && formData.parentFormId != null && formData.parentFormId !== 'N/A' ? formData.parentFormId : formData.itemId }/${ formData.accountId }`));
  };

  navigateToWithholdingStatement = (accountId) => {
    const { dispatch } = this.props;
    dispatch(push(`/whd-statement/${ accountId }`));
  };

  render() {
    const {
      data,
      searchCriteria,
      gridCriteria,
      loading,
      showWorkflowButtons,
      initialLoaded
    } = this.state;
    const {
      dispatch,
      settings,
      isAddFormModalShown,
      isDeleteFormModalShown,
      isDeletingForm,
      isAccountWithholdingShown,
      isParentImyFormsShown,
      isAddBeneficiarFormModalShown,
      isAddingImyToExistingLayer,
      isOwnershipModalShown,
      isAssignToUserModalShown,
      isUnassignModalShown,
      isEditFormReferenceModalShown,
      changeOwnershipItem,
      deleteFormError,
      permissions
    } = this.props;

    const selectionEnabled = this.getIsSelectionEnabled();
    return (
      <div className="landing-page">
        <SearchPanel
          title={
            <React.Fragment>
              Search
              { (settings && settings.showScannedForms) && <AccessControl
                matchAll
                allowedPermissions={ [ActivityPerms.scannedUpload,
                  ActivityPerms.scannedEdit,
                  ActivityPerms.scannedValidate] }
              >
                {!settings.selectedClient.isPiiProtectionEnabled && <button
                  id="add-form-btn"
                  type="button"
                  title="Add form"
                  className="btn btn-primary add-form-btn"
                  onClick={ () => dispatch(showAddFormModal(null, null)) }
                >
                  ADD FORM
                </button>}
              </AccessControl> }
              { (searchCriteria.gridType === 'accounts' || searchCriteria.gridType === 'customers') && <AccessControl
                matchAll
                allowedPermissions={ [ActivityPerms.customerEdit, ActivityPerms.accountEdit] }
              >
                <Link to="/customer/add">
                  <button type="button" className="btn btn-primary add-form-btn">ADD {searchCriteria.gridType === 'accounts' ? 'ACCOUNT' : 'CUSTOMER'}</button>
                </Link>
              </AccessControl> }
            </React.Fragment>
          }
          searchCriteria={ searchCriteria }
          onSearchCriteriaChanged={ this.onSearchCriteriaChanged }
          onSearchClicked={ this.fetchData }
          permissions={ permissions }
        />
        <div className="panel search-panel mt">
          <div className={ `panel-body results ${ searchCriteria.gridType === 'forms' ? 'form-results' : '' }` }>
            { showWorkflowButtons ? <div className="form-tabs">
              <button
                id="workflow-mywork-btn"
                type="button"
                className={ `btn btn-${ searchCriteria.workflowType === 'mywork' ? 'primary' : 'secondary' }` }
                onClick={ () => this.onWorkflowTypeChanged('mywork') }
              >My Work</button>
              <AccessControl allowedPermissions={ [ActivityPerms.fwfInitialReviewer] }>
                <button
                  id="workflow-initialreview-btn"
                  type="button"
                  className={ `btn btn-${ searchCriteria.workflowType === 'initialreview' ? 'primary' : 'secondary' }` }
                  onClick={ () => this.onWorkflowTypeChanged('initialreview') }
                >Pending Initial Review</button>
              </AccessControl>
              <AccessControl allowedPermissions={ [ActivityPerms.fwfSecondaryReviewer] }>
                <button
                  id="workflow-secondaryreview-btn"
                  type="button"
                  className={ `btn btn-${ searchCriteria.workflowType === 'secondaryreview' ? 'primary' : 'secondary' }` }
                  onClick={ () => this.onWorkflowTypeChanged('secondaryreview') }
                >Pending Secondary Review</button>
              </AccessControl>
              <AccessControl allowedPermissions={ [ActivityPerms.fwfExpertReviewer] }>
                <button
                  id="workflow-managerreview-btn"
                  type="button"
                  className={ `btn btn-${ searchCriteria.workflowType === 'managerreview' ? 'primary' : 'secondary' }` }
                  onClick={ () => this.onWorkflowTypeChanged('managerreview') }
                >Pending Expert Review</button>
              </AccessControl>
              <button
                id="workflow-complete-btn"
                type="button"
                className={ `btn btn-${ searchCriteria.workflowType === 'complete' ? 'primary' : 'secondary' }` }
                onClick={ () => this.onWorkflowTypeChanged('complete') }
              >Complete</button>
              <AccessControl allowedPermissions={ [ActivityPerms.scannedView, ActivityPerms.electronicView] }>
                <button
                  id="workflow-allforms-btn"
                  type="button"
                  className={ `btn btn-${ searchCriteria.workflowType === 'allforms' ? 'primary' : 'secondary' }` }
                  onClick={ () => this.onWorkflowTypeChanged('allforms') }
                >All Forms</button>
              </AccessControl>
              { selectionEnabled && searchCriteria.workflowType === 'allforms' && <ActionSelect
                selectedItems={ gridCriteria.selectedItems }
                openAssignToUserModal={ this.openAssignToUserModal }
                openDeleteFormModal={ this.openDeleteFormModal }
                openEditFormReferenceModal={ this.openEditFormReferenceModal }
              /> }
            </div> : <div className="mt-5" />}
            <ReactTable
              data={ data }
              gridCriteria={ gridCriteria }
              onGridCriteriaChanged={ this.onGridCriteriaChanged }
              onRowSelectionChanged={ this.onRowSelectionChanged }
              onRowExpandedStateChanged={ this.onRowExpandedStateChanged }
              childRowPropertyName="additionalData"
              getChildRowLayout={ childData => this.getChildRowLayout(childData) }
              actions={ this.getActions() }
              enableExpandCollapse={ this.getIsExpandCollapseEnabled() }
              enableSelection={ selectionEnabled }
              loading={ loading }
              initialLoaded={ initialLoaded }
              className={ selectionEnabled ? 'workflow' : '' }
            />
          </div>
        </div>
        {!settings.selectedClient.isPiiProtectionEnabled && <AddFormModal
          isShown={ isAddFormModalShown }
          onConfirmUpload={ (parentForm, values) => this.addFormAction(parentForm, values, false) }
          onCancel={ () => this.closeAddFormModal() }
        />}
        <DeleteFormModal
          isShown={ isDeleteFormModalShown }
          isDeletingForm={ isDeletingForm }
          onConfirmDelete={ () => this.processDeleteForms() }
          onCancel={ () => this.closeDeleteFormModal() }
          deleteFormError={ deleteFormError }
        />
        <WithholdingRatesModal
          isShown={ isAccountWithholdingShown }
          onClose={ () => this.closeAccountWithholdingModal() }
        />
        <CustomerImyFormsModal
          isShown={ isParentImyFormsShown }
          onClose={ () => this.closeParentImyFormsModal() }
        />
        <AddBeneficiaryFormModal
          isShown={ isAddBeneficiarFormModalShown }
          addImyToExistingLayer={ isAddingImyToExistingLayer }
          onConfirmUpload={ values => this.addBeneficiaryForms(values) }
          onImyChange={ value => this.imyChange(value) }
          onCancel={ () => this.closeAddBeneficiaryFormModal() }
        />
        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }
        { isEditFormReferenceModalShown && <EditFormReferenceModal
          isShown={ isEditFormReferenceModalShown }
          onCancel={ () => this.closeEditFormReferenceModal() }
          onConfirmFormReferenceChange={ (formId, newFormRef) => this.processEditFormReference(formId, newFormRef) }
        /> }
        <AssignToUserModal
          isShown={ isAssignToUserModalShown }
          onCancel={ () => this.closeAssignToUserModal() }
          onConfirmAssign={ (formsList, user) => this.processAssignToUsers(formsList, user) }
          getItemsList={ () => this.getItemsList() }
        />
        <UnassignToUserModal
          isShown={ isUnassignModalShown }
          onCancel={ () => this.closeUnassignFormModal() }
          onConfirmUnassign={ () => this.processUnassignToUsers() }
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions,
      settings
    },
    home: {
      searchCriteria,
      gridCriteria
    },
    forms: {
      forms,
      formsCount,
      isAddFormModalShown,
      isAssignToUserModalShown,
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError,
      isAccountWithholdingShown,
      isAddBeneficiarFormModalShown,
      isEditFormReferenceModalShown,
      parentW8ImyForm,
      isUnassignModalShown,
      isParentImyFormsShown,
      formsList
    },
    customer: {
      customers,
      customersCount
    },
    account: {
      accounts,
      accountsCount
    },
    legalEntities: {
      legalEntities,
      legalEntitiesCount
    },
    workflow: {
      isFetchingQueues,
      isGettingAccounts,
      isGettingCustomers,
      isGettingForms,
      isOwnershipModalShown,
      changeOwnershipItem
    },
    workflow
  } = state;
  return {
    permissions,
    settings,
    forms,
    formsCount,
    isAddFormModalShown,
    isAssignToUserModalShown,
    isDeleteFormModalShown,
    isDeletingForm,
    deleteFormError,
    isAccountWithholdingShown,
    isParentImyFormsShown,
    isAddBeneficiarFormModalShown,
    isEditFormReferenceModalShown,
    parentW8ImyForm,
    formsList,
    customers,
    customersCount,
    accounts,
    accountsCount,
    legalEntities,
    legalEntitiesCount,
    isFetchingQueues,
    isGettingAccounts,
    isGettingCustomers,
    isGettingForms,
    isOwnershipModalShown,
    changeOwnershipItem,
    isUnassignModalShown,
    userQueue: workflow.userQueue?.items,
    userCount: workflow.userQueue?.totalCount,
    initialReviewQueue: workflow.initialReviewQueue?.items,
    initialReviewCount: workflow.initialReviewQueue?.totalCount,
    secondaryReviewQueue: workflow.secondaryReviewQueue?.items,
    secondaryReviewCount: workflow.secondaryReviewQueue?.totalCount,
    expertReviewQueue: workflow.expertReviewQueue?.items,
    expertReviewCount: workflow.expertReviewQueue?.totalCount,
    completeQueue: workflow.completeQueue?.items,
    completeCount: workflow.completeQueue?.totalCount,
    initSearchCriteria: searchCriteria,
    initGridCriteria: gridCriteria
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(Home, 'Home'));
